import React, { Component } from 'react';
import { Modal, Button, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { notify } from 'react-notify-toast';

type IProps = {
  item: Object,
  onClose: () => void,
  onSave: (item: Object) => void,
}

type IState = {
  key: string,
  title: string,
  body: string,
}

class ModalNotification extends Component {

  constructor(props: IProps) {
    super(props);

    this.state = {
      key: '',
      title: '',
      body: '',
    };
  }  

  state: IState;

  componentWillReceiveProps(nextProps: IProps) {
    const { item } = nextProps;

    if (item) {
      const key = item.key || '';
      const title = item.title || '';
      const body = item.body || '';
    
      this.setState({
        key,
        title,
        body,
      });
    }
  }

  handleOnSave(e) {
    const { onSave } = this.props;
    const { key, title, body } = this.state;

    if (title.length === 0 || body.length === 0) {
      notify.show('Please fill correctly!', 'warning', 3000);
      return;
    }

    onSave({
      key,
      title,
      body,
    });
  }

  handleOnClose(e) {
    const { onClose } = this.props;

    onClose();
  }
  
  handleChangeTitle(e) {
    this.setState({
      title: e.target.value
    });
  }
    
  handleChangeBody(e) {
    this.setState({
      body: e.target.value
    });
  }

  props: IProps;

  render() {
    const { title, body } = this.state;

    if (!this.props.item) {
      return (
        <Modal show={false} />
      );
    }
   
    let modalTitle = 'Send notification';
    if (this.props.item.key) {
      modalTitle = `Detail of notification`;
    }

    return (
      <Modal show={this.props.item ? true : false} onHide={this.handleOnClose.bind(this)} backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="title">
            <ControlLabel>Title</ControlLabel>
            <FormControl id="title" type="text" onChange={this.handleChangeTitle.bind(this)} value={title} />
          </FormGroup>
          <FormGroup controlId="body">
            <ControlLabel>Body</ControlLabel>
            <FormControl id="body" componentClass="textarea" onChange={this.handleChangeBody.bind(this)} value={body} />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleOnClose.bind(this)}>Close</Button>
          {
            !this.props.item.key && <Button bsStyle="primary" onClick={this.handleOnSave.bind(this)}>Send</Button>
          }
        </Modal.Footer> 
      </Modal>
    );
  }
}

export default ModalNotification;



// WEBPACK FOOTER //
// ./src/pages/Notifications/ModalNotification.js